var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16762 15.9023H3.33429L4.16762 10.069H1.25095C0.517619 10.069 0.975953 9.44401 0.992619 9.41901C2.06762 7.51901 3.68429 4.68568 5.84262 0.902344H6.67595L5.84262 6.73568H8.76762C9.10095 6.73568 9.28429 6.89401 9.10095 7.28568C5.80929 13.0273 4.16762 15.9023 4.16762 15.9023Z",
    fill: "#278351"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/trigger.3ff34185.svg";
export { ForwardRef as ReactComponent };